import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AdvertisingPlatformInfoForm} from './advertising-platform-info-form';

export class OutbrainInfoForm extends AdvertisingPlatformInfoForm {

  constructor() {
    super();
    this.formGroup = new FormGroup({
      currencyId: new FormControl('', Validators.required),
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      marketerId: new FormControl('', Validators.required),
    });
  }

  static override getPlatformName(): string {
    return 'outbrain';
  }
}
